import DateInput from '../../Inputs/DateInput/DateInput';
import makeTextWidget from './makeTextWidget';
export default makeTextWidget(DateInput);